import React from 'react';
import { Backdrop, Box, CircularProgress, Typography } from '@mui/material';

interface FullScreenLoaderProps {
  open: boolean;
  message?: string;
}

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({open,message = 'Cargando...',}) => {
    return (
        <Backdrop
        sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.modal + 1,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'rgba(0, 0, 50, 0.8)', // Fondo oscuro con tinte azul
        }}
        open={open}
        >
        <CircularProgress sx={{ color: '#00BFFF' }} /> {/* Azul claro tipo "Deep Sky Blue" */}
        <Box mt={2}>
            <Typography variant="h6" sx={{ textAlign: 'center' }}>
            {message}
            </Typography>
        </Box>
        </Backdrop>
    );
};

export default FullScreenLoader;
